import Image from 'next/image'

export function EmptyGroupedActivity() {
  return (
    <div className='flex flex-col text-center items-center pt-8 pb-16 gap-6'>
      <Image
        src='/assets/cactus.png'
        alt='Cactus in desert'
        width={240}
        height={240}
      />
      <div className='flex flex-col gap-3'>
        <span className='text-4xl text-primary font-serif font-extralight'>
          No activity yet
        </span>
        <span className='text-secondary text-sm'>
          Your trades on Polaris will appear here.
        </span>
      </div>
    </div>
  )
}
